import { NowConditionsProvider } from '../providers/nowConditionsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_NOW_CONDITIONS = new AsyncAction('GET_NOW_CONDITIONS');

export function getNowConditions(...params) {

    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        fml: undefined,
        stationId: undefined,
        providerId: undefined,
        temperatureUnit: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        roundingProfile: undefined,
        verbose: undefined,
        refresh: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_NOW_CONDITIONS.base,
        payload: getNowCondition(paramsObject)
    };
}

export async function getNowCondition({ latitude, longitude, fml, stationId, providerId, temperatureUnit, baseUrl, authId, secret, stdParameters, roundingProfile, verbose, refresh }) {
    const op = new NowConditionsProvider(baseUrl, authId, secret);
    return await op.getNowConditions(latitude, longitude, fml, stationId, providerId, temperatureUnit, stdParameters, roundingProfile, verbose, refresh);
}
